import marquee01 from '../assets/img/marquee/marquee1.jpg'
import marquee02 from '../assets/img/marquee/marquee2.jpg'
import marquee03 from '../assets/img/marquee/marquee3.jpg'
import marquee04 from '../assets/img/marquee/marquee4.jpg'
import marquee05 from '../assets/img/marquee/marquee5.jpg'
import marquee06 from '../assets/img/marquee/marquee6.jpg'
import marquee07 from '../assets/img/marquee/marquee7.jpg'
import marquee08 from '../assets/img/marquee/marquee8.jpg'
import marquee09 from '../assets/img/marquee/marquee9.jpg'
import marquee10 from '../assets/img/marquee/marquee10.jpg'
import marquee11 from '../assets/img/marquee/marquee12.jpg'
import marquee12 from '../assets/img/marquee/marquee13.jpg'

export const marqueeData = [
    [
        {
            src: marquee01,
            alt: "Marquee #01",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee02,
            alt: "Marquee #02",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee03,
            alt: "Marquee #03",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee04,
            alt: "Marquee #04",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee05,
            alt: "Marquee #05",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee11,
            alt: "Marquee #11",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
    ],
    [
        {
            src: marquee06,
            alt: "Marquee #06",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee07,
            alt: "Marquee #07",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee08,
            alt: "Marquee #08",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee09,
            alt: "Marquee #09",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee10,
            alt: "Marquee #10",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
        {
            src: marquee12,
            alt: "Marquee #12",
            title: "Мария Маринова",
            city: "София",
            age: "9",
            caseTitle: "Детска ортодонтия",
            caseHref: "/services",
            description: "С над 20-годишен опит нашата дентална клиника си е изградила репутация на отличен специалист. Нашият екип е в крак с най-новите дентални технологии и техники, за да гарантираме, че получавате възможно най-доброто лечени.",
            testimonialName: "Петя Иванова",
            testimonialComment: "Дъщеря ни за пръв път не се разплака при зъболекаря, много сме доволни, блаблабла.",
        },
    ]
]